import {
  useMostPlayedSubFlow,
  useMultiClipSubFlow,
  useSingleClipSubFlow,
} from './subflows';
import { VideoSubFlowProps } from './types';

type UseVideoSubFlowProps = VideoSubFlowProps;

export default function useVideoSubFlow(props: UseVideoSubFlowProps) {
  const {
    state: { objective },
  } = props;

  const singleClipSubFlow = useSingleClipSubFlow(props);
  const multiClipSubFlow = useMultiClipSubFlow(props);
  const mostPlayedSubFlow = useMostPlayedSubFlow(props);

  if (objective === 'SingleClip') {
    return singleClipSubFlow;
  }

  if (objective === 'MultipleClips') {
    return multiClipSubFlow;
  }

  return mostPlayedSubFlow;
}
